import { render, staticRenderFns } from "./actionPlan.vue?vue&type=template&id=4789732a&scoped=true"
import script from "./actionPlan.vue?vue&type=script&lang=js"
export * from "./actionPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4789732a",
  null
  
)

export default component.exports